<div class="calendar-container" #container>
  <div class="calendar-header sticky-header"
  [ngClass]="{'calendar-header-wrapper': hasSelectedActivity}">
    <div class="left-header">
      <span class="currentMonth">{{getTopActivityMonthYear}}</span>
      <ion-buttons slot="end">
        <ion-button class="calendar-icn" (click)="openCalendar($event)" [class.active]="calendarIsOpen">
          <ion-icon slot="icon-only" src="assets/imgs/calendar-icon.svg"></ion-icon>
        </ion-button>
        <ion-button class="calendar-chevron" *ngIf="newHomeView == 'calendarView'" (click)="activityCalendar?.navigatePage(true)">
          <ion-icon name="chevron-back-outline" slot="icon-only"></ion-icon>
        </ion-button>
        <ion-button class="today" (click)="onTodayClick()">
          <ion-icon slot="start" [src]="'assets/imgs/goto-today-icon.svg'"></ion-icon>
          {{'TODAY' | translate}}
        </ion-button>
        <ion-button class="calendar-chevron" *ngIf="newHomeView == 'calendarView'" (click)="activityCalendar?.navigatePage(false)">
          <ion-icon name="chevron-forward-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
    <div class="right-header">
      <ion-buttons slot="end">
        <ion-button icon-only (click)="calendarIsMaximized = !calendarIsMaximized" [tooltip]="calendarIsMaximized ? 'Restore' : 'Expand'" (events)="onTooltipVisibilityChange()" *ngIf="!device.isMobileDevicePortrait" class="calendar-maximize-button">
          <ion-icon [src]="'assets/imgs/calendar-' + (calendarIsMaximized ? 'restore' : 'maximize') + '.svg'" class="calendar-maximize-icon"></ion-icon>
        </ion-button>
        <ion-button class="filter-button" [ngClass]="{'selected': activityService.multiOptionActivityFilter?.length > 0}" icon-only (click)="openFilterOptions()">
          <ion-icon src="assets/imgs/header_filter.svg" class="filter-icon"></ion-icon>
        </ion-button>
        <ion-button [ngClass]="{'selected': showSearchBar}" icon-only (click)="toggleSearchBar()">
          <ion-icon src="assets/imgs/search-grey-icon.svg" class="search-icon"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons class="view" slot="end">
        <ion-button class="list-icon" icon-only [ngClass]="{'selectedView':   newHomeView == 'listView'}" (click)="openListView()">
          <ion-icon
            [src]="newHomeView == 'listView' ? 'assets/imgs/list-view-icon-white.svg' : 'assets/imgs/list-view-icon.svg'">
          </ion-icon>
        </ion-button>
        <ion-button class="calendar-icn" icon-only [ngClass]="{'selectedView': newHomeView == 'calendarView'}" (click)="openCalendarView()">
          <ion-icon
            [src]="newHomeView == 'calendarView' ? 'assets/imgs/calendar-white.svg' : 'assets/imgs/calendar-grey.svg'">
          </ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
  <div class="search-bar-container" *ngIf="showSearchBar">
    <ion-searchbar autoFocusSearchbar [(ngModel)]="activityService.activitiesSearchText" (ionInput)="onInput($event)" [debounce]="300" show-clear-button="never" class="home-screen-searchbar">
    </ion-searchbar>
    <ion-icon *ngIf="activityService.activitiesSearchText?.length > 0" name="close-outline" class="home-screen-close-icon" (click)="clearSearchBar()"></ion-icon>
  </div>
  <div class="scrollable-content" *ngIf="newHomeView == 'listView'">
    <activities-pane (scrolledDateChange)="activityPaneDate = $event" (activityOpenedFromActivities)="onActivityClick($event)"></activities-pane>
  </div>
  <ng-container *ngIf="newHomeView == 'calendarView'">
    <activity-calendar (newActivityOpened)="onNewActivityOpened($event)" (onActivityClick)="onActivityClick($event)" [calendarSearchText]="activityService.activitiesSearchText"></activity-calendar>
  </ng-container>
</div>